import React from 'react';
import PwaInstallHelpSheet from './PwaInstallHelpSheet';
import usePwaInstallRecovery from './usePwaInstallRecovery';
import './installButton.css';

const InstallButton = ({ suppressCompactPrompt = false }) => {
  const install = usePwaInstallRecovery('feed');

  if (!install.shouldShowInstallUi) return null;
  if (install.showCompactPrompt && suppressCompactPrompt) return null;

  return (
    <div className="installButton">
      {install.showFullPrompt ? (
        <section className="pwaInstallPromo" aria-label="Install Joe Galaxy">
          <div>
            <div className="pwaInstallPromoEyebrow">JG LocalOps</div>
            <h2>Keep JG LocalOps on your phone</h2>
            <p>
              Open tasks, rides, and local offers from your Home Screen.
            </p>
            {install.canNativeInstall ? (
              <p className="pwaInstallReward">
                Install and open from your Home Screen to earn 100 JGK.
              </p>
            ) : (
              <p className="pwaInstallReward">
                Open from your Home Screen to finish setup.
              </p>
            )}
          </div>
          <div className="pwaInstallPromoActions">
            <button
              className="pwaInstallPromoPrimary"
              onClick={install.openHelpSheet}
              type="button"
            >
              Get the app
            </button>
            <button
              className="pwaInstallPromoSecondary"
              onClick={install.snoozeFullPrompt}
              type="button"
            >
              Not now
            </button>
          </div>
        </section>
      ) : (
        <button
          className="pwaInstallCompact"
          onClick={install.openHelpSheet}
          type="button"
        >
          <span>Get the app</span>
          <small>Open from your Home Screen.</small>
        </button>
      )}

      <PwaInstallHelpSheet
        canNativeInstall={install.canNativeInstall}
        nativePromptDismissed={install.nativePromptDismissed}
        onClose={install.closeHelpSheet}
        onInstall={install.promptNativeInstall}
        open={install.isSheetOpenForOwner}
        platform={install.platform}
      />
    </div>
  );
};

export default InstallButton;
